// Mobile app version helpers for the App Version & Force Update settings page.

// Same strict x.y.z format the backend accepts.
const SEMVER = /^\d+\.\d+\.\d+$/;

// Numeric x.y.z comparison: -1, 0 or 1.
export const compareVersions = (a, b) => {
	const pa = a.split(".").map(Number);
	const pb = b.split(".").map(Number);
	for (let i = 0; i < 3; i++) {
		if (pa[i] !== pb[i]) return pa[i] < pb[i] ? -1 : 1;
	}
	return 0;
};

/** Client-side check mirroring the backend rule: required <= recommended <= latest. */
export const validateMinVersion = (version, config) => {
	if (!SEMVER.test(version || "")) {
		return "Enter a version like 1.0.18";
	}
	if (
		config?.latest_version &&
		compareVersions(version, config.latest_version) > 0
	) {
		return `Cannot be above the latest version (${config.latest_version})`;
	}
	if (
		config?.min_recommended_version &&
		compareVersions(version, config.min_recommended_version) > 0
	) {
		return `Cannot be above the recommended version (${config.min_recommended_version})`;
	}
	return null;
};
